module.exports = __webpack_public_path__ + "static/img/hangyeli4.02c2dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/hangyeli4.png
// module id = aeO1
// module chunks = 5